import queryString from 'query-string'; // eslint-disable-line

export const getQueryVar = (key) => {
    const parsedQuery = queryString.parse(window.location.search);
    if (parsedQuery[key]) {
        return parsedQuery[key];
    }
    return null;
};

export default getQueryVar;
